/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import uniq from 'lodash/uniq'
import type { UpdateableGroup } from '../index'

import { getGroupSubstrateChildren } from '../get-group-substrate-children/get-group-substrate-children'
import { updateGroup } from '../update-group/update-group'

import { getItem } from '../../items/get-items/get-item/get-item'
import { getFileKeysForItem } from '../../files/get-file-keys-for-item/get-file-keys-for-item'

export function addItemsToGroup(args: {
  quote: QuoteDocument
  options: OptionsDocument
  group: UpdateableGroup
  keys: string[]
}): QuoteDocument {
  const { quote, options, group, keys } = args

  const items = keys.map((key) => getItem({ quote, options, key }))

  // get file keys from item and add to group
  const files = [
    ...group.files,
    ...items.reduce((allFiles, item) => {
      return [...allFiles, ...getFileKeysForItem({ item })]
    }, [])
  ]

  const updatedGroup: UpdateableGroup = {
    ...group,
    children: [...keys, ...group.children],
    substrateChildren: uniq([
      ...(group?.substrateChildren ?? []),
      ...getGroupSubstrateChildren({ quote, options, section: group.section, keys })
    ]),
    files
  }

  const updatedQuote = updateGroup({
    quote,
    options,
    group: updatedGroup,
    calculate: true
  })

  return updatedQuote
}
